<main class="site-main">
    <!-- START OF MAIN BANNER -->
    <section class="inner-banner back-img" style="background-image: url('assets/img/about-us-banner-new.jpg');">
        <div class="banner-stripes">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="banner-shape-wp wow fadeInRight for-des" data-wow-duration=".8s">
            <div class="banner-shape">
                <span class="stripe"></span>
                <span class="stripe stripe-secondary"></span>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="inner-banner-content-wp white-text text-center">
                        <div class="inner-banner-content wow fadeInUp" data-wow-duration=".8s">
                            <h2 class="h2-title mb-0 mt-5">Contact Us</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF MAIN BANNER -->
    <section class="contact-main">
        <div class="contact-offices">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="contact-office wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                            <h4 class="h4-title">Main Office</h4>
                            <ul>
                                <li>
                                    <a href="tel:+971581292000" title="Call on +971 58 129 2000">
                                        <img src="assets/img/phone-icon.svg" width="18" height="18" alt="Phone Icon">
                                        <span>+971 58 129 2000</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="mailto:goldendropoilind@gmail.com " title="Mail on goldendropoilind@gmail.com ">
                                        <img src="assets/img/mail-icon.svg" width="18" height="13" alt="Mail Icon">
                                        <span>goldendropoilind&#64;gmail.com</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://maps.app.goo.gl/BWyoU2MVUnQa7JEf7"
                                        title="Al Sajaa industrial area, Near Cement factory, Sharjah, UAE" target="_blank">
                                        <img src="assets/img/map-pin-transparent.svg" width="15" height="20"
                                            alt="Map Icon">
                                        <span>
                                            Al Sajaa industrial area, Near Cement factory, Sharjah, UAE
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- <div class="col-lg-4">
                        <div class="contact-office wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                            <h4 class="h4-title">New York Office</h4>
                            <ul>
                                <li>
                                    <a href="tel:+19879874987" title="Call on +1 987 9874 987">
                                        <img src="assets/img/phone-icon.svg" width="18" height="18"
                                            alt="Phone Icon">
                                        <span>+1 987 9874 987</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://html.geekcodelab.com/cdn-cgi/l/email-protection#2f464149406f46414b5a5d465c014c4042" title="Mail on goldendropoilind@gmail.com ">
                                        <img src="assets/img/mail-icon.svg" width="18" height="13"
                                            alt="Mail Icon">
                                        <span><span class="__cf_email__" data-cfemail="ec85828a83ac858288999e859fc28f8381">[email&#160;protected]</span></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://maps.app.goo.gl/4saWZVwFZxgN99bD8" title="8/05 Mozilla Golden"
                                        target="_blank">
                                        <img src="assets/img/map-pin-transparent.svg" width="15" height="20"
                                            alt="Map Icon">
                                        <span>8/05 Mozilla Golden</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="contact-office wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                            <h4 class="h4-title">Hong Kong Office</h4>
                            <ul>
                                <li>
                                    <a href="tel:+869879874987" title="Call on +86 987 9874 987">
                                        <img src="assets/img/phone-icon.svg" width="18" height="18"
                                            alt="Phone Icon">
                                        <span>+86 987 9874 987</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://html.geekcodelab.com/cdn-cgi/l/email-protection#8be2e5ede4cbe2e5effef9e2f8a5e8e4e6" title="Mail on goldendropoilind@gmail.com ">
                                        <img src="assets/img/mail-icon.svg" width="18" height="13"
                                            alt="Mail Icon">
                                        <span><span class="__cf_email__" data-cfemail="630a0d050c230a0d0716110a104d000c0e">[email&#160;protected]</span></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://maps.app.goo.gl/Kbaa2xfsBPwUq1nV7" title="8/05 Mozilla Golden"
                                        target="_blank">
                                        <img src="assets/img/map-pin-transparent.svg" width="15" height="20"
                                            alt="Map Icon">
                                        <span>8/05 Mozilla Golden</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="main-contact">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 order-lg-1 order-2">
                        <div class="main-contact-map wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115368.00213450495!2d55.46414814957067!3d25.362934264814818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef5f2d9741a463b%3A0x6147e32b2353f5cf!2sAl%20sajaa%20Concrete%20Products%20Factory%20L.L.C!5e0!3m2!1sen!2sin!4v1739642830848!5m2!1sen!2sin"
                                style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-2 order-1">
                        <div class="main-contact-form wow fadeInRight" data-wow-duration=".8s" data-wow-delay=".2s">
                            <div class="sec-title">
                                <span class="sub-title">
                                    <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                    CONTACT US
                                </span>
                                <h2 class="mb-4">Let Start The Smart Work !</h2>
                            </div>
                            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-field">
                                            <input type="text" class="form-control" placeholder="Full Name"
                                                formControlName="name">
                                            <div *ngIf="submitted && con['name'].errors" class="abs-error">
                                                <div *ngIf="con['name'].errors['required']">Full Name is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-field">
                                            <input type="email" class="form-control" placeholder="Email Address"
                                                formControlName="email">
                                            <div *ngIf="submitted && con['email'].errors" class="abs-error">
                                                <div *ngIf="con['email'].errors['required']">Email is required</div>
                                                <div *ngIf="con['email'].errors['pattern']">Please enter a valid email
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-field">
                                            <input type="text" class="form-control" placeholder="Phone No."
                                                formControlName="phone" (keypress)="numberOnly($event)" />
                                            <div *ngIf="submitted && con['phone'].errors" class="abs-error">
                                                <div *ngIf="con['phone'].errors['required']">
                                                    Phone number is required
                                                </div>
                                                <div *ngIf="con['phone'].errors['minlength']">
                                                    Minimum 10 numbers required
                                                </div>
                                                <div *ngIf="con['phone'].errors['maxlength']">
                                                    Maximum 10 numbers required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-field">
                                            <textarea name="message" class="form-control" placeholder="Message..."
                                                formControlName="message"></textarea>
                                            <div *ngIf="submitted && con['message'].errors" class="abs-error">
                                                <div *ngIf="con['message'].errors['required']">Message is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-field form-submit-btn">
                                            <button type="submit" class="sec-btn">Submit now</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>